import ResponseError from 'components/Page/ResponseError/index';
import { STATUS_400 } from 'domain/constants/responseStatus';
import React from 'react';

const ResponseError400 = () => {
    return <ResponseError responseStatus={STATUS_400.toString()} errorText='An error occurred' />;
};

export default ResponseError400;
